import { useState } from 'react';
import { Phone, Mail, MapPin } from 'lucide-react';
import ContactFormDialog from './ContactFormDialog';

export const LandingNavigation = () => {
  const [showDialog, setShowDialog] = useState(false);

  return (
    <>
      <nav className="fixed top-0 left-0 right-0 z-50 glass shadow-md">
        {/* Top Bar Strip */}
        <div className="bg-[#06214c] text-white text-[13px] max-[576px]:text-[11px] py-2">
          <div className="container mx-auto px-4 flex items-center justify-end max-[576px]:justify-center gap-6 max-[576px]:gap-3">
            <div className="flex items-center gap-2">
              <Phone size={14} className="flex-shrink-0" />
              <a href="tel:+10000000000" className="hover:underline">+1-000-000-0000</a>
            </div>
            <div className="flex items-center gap-2 max-[576px]:hidden">
              <Mail size={14} className="flex-shrink-0" />
              <a href="mailto:info@ipprotectionassociate.com" className="hover:underline">info@ipprotectionassociate.com</a>
            </div>
            <div className="flex items-center gap-2 max-[767px]:hidden">
              <MapPin size={14} className="flex-shrink-0" />
              <span>Old Middlefield Way, Mountain View, CA 94043</span>
            </div>
          </div>
        </div>

        <div className="container mx-auto px-4">
          <div className="flex items-center justify-between h-20">
            {/* Logo */}
            <img src="/assets/img/logo-color.png" width="200" alt="IP Protection Associate Logo" />

            {/* Right Side Buttons */}
            <div className="flex items-center space-x-4">
              <button
                onClick={() => setShowDialog(true)}
                className="btn-primary max-[576px]:hidden"
                data-testid="lp-register-trademark-btn"
              >
                Register My Trademark
              </button>
              <button className="js-chat btn-secondary" data-testid="lp-chat-now-btn">
                Chat Now
              </button>
            </div>
          </div>
        </div>
      </nav>

      <ContactFormDialog open={showDialog} onOpenChange={setShowDialog} source="popup" />
    </>
  );
};

export default LandingNavigation;